import React from 'react';
import { FileText, AlertTriangle } from 'lucide-react';

const TaxAccountingSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <FileText className="w-5 h-5 mr-2 text-indigo-500" />
        Налоговый учет амортизации
      </h3>
      
      {/* Включить налоговый учет */}
      <div className="mb-4">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeTaxCalculation"
            checked={formData.includeTaxCalculation}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Рассчитать амортизацию для налогового учета
          </span>
        </label>
      </div>
      
      {formData.includeTaxCalculation && (
        <>
          {/* Метод налогового учета */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
            <label className={`
              flex items-start p-3 border rounded-lg cursor-pointer transition-colors
              ${formData.taxMethod === 'linear' 
                ? 'bg-blue-50 border-blue-200 dark:bg-blue-900/20 dark:border-blue-700' 
                : 'bg-white border-gray-200 dark:bg-gray-700 dark:border-gray-600'}
            `}>
              <input
                type="radio"
                name="taxMethod"
                value="linear"
                checked={formData.taxMethod === 'linear'}
                onChange={handleInputChange}
                className="form-radio mt-1"
              />
              <div className="ml-3">
                <span className="block text-sm font-medium text-gray-900 dark:text-white">
                  Линейный метод
                </span>
                <span className="block text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Равномерное списание стоимости в течение срока полезного использования
                </span>
              </div>
            </label>
            
            <label className={`
              flex items-start p-3 border rounded-lg cursor-pointer transition-colors
              ${formData.taxMethod === 'non_linear' 
                ? 'bg-blue-50 border-blue-200 dark:bg-blue-900/20 dark:border-blue-700' 
                : 'bg-white border-gray-200 dark:bg-gray-700 dark:border-gray-600'}
            `}>
              <input
                type="radio"
                name="taxMethod"
                value="non_linear"
                checked={formData.taxMethod === 'non_linear'}
                onChange={handleInputChange}
                className="form-radio mt-1"
              />
              <div className="ml-3">
                <span className="block text-sm font-medium text-gray-900 dark:text-white">
                  Нелинейный метод
                </span>
                <span className="block text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Ускоренное списание с фиксированными нормами для каждой амортизационной группы
                </span>
              </div>
            </label>
          </div>
          
          {/* Информация о налоговых методах */}
          <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
            <div className="flex items-start">
              <FileText className="w-4 h-4 text-blue-500 mt-1 mr-2" />
              <div>
                <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300">
                  Особенности налогового учета амортизации в России
                </h4>
                <ul className="list-disc list-inside text-xs text-blue-600 dark:text-blue-400 mt-1">
                  <li><strong>Линейный метод</strong> — применяется к зданиям, сооружениям, передаточным устройствам (8-10 группы) и всем ОС со сроком более 20 лет.</li>
                  <li><strong>Нелинейный метод</strong> — можно применять ко всем остальным ОС. Нормы амортизации фиксированы для каждой группы.</li>
                  <li>Для нелинейного метода амортизация начисляется на остаток амортизационной группы.</li>
                  <li>При остатке ниже 20% от первоначальной стоимости, его списывают равными частями.</li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* Предупреждение о разнице между бухгалтерским и налоговым учетом */}
          <div className="mt-4 bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-lg border border-yellow-100 dark:border-yellow-800">
            <div className="flex items-start">
              <AlertTriangle className="w-4 h-4 text-yellow-500 mt-1 mr-2" />
              <div>
                <h4 className="text-sm font-medium text-yellow-700 dark:text-yellow-300">
                  Внимание: временные разницы
                </h4>
                <p className="text-xs text-yellow-600 dark:text-yellow-400 mt-1">
                  Различия между бухгалтерским и налоговым учетом амортизации приводят к образованию 
                  временных разниц и отложенных налоговых активов/обязательств. 
                  Регулируется ПБУ 18/02 «Учет расчетов по налогу на прибыль организаций».
                </p>
              </div>
            </div>
          </div>
        </>
      )}
      
      {!formData.includeTaxCalculation && (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Включите этот параметр, чтобы увидеть разницу между бухгалтерским и налоговым учетом амортизации и рассчитать временные разницы.
        </p>
      )}
    </div>
  );
};

export default TaxAccountingSection;